module.exports = __webpack_public_path__ + "static/media/image_3.0351d6a2.svg";